import React, { Component } from "react";
import PropTypes from "prop-types";
import { Fieldset, Field, Control, Label, Input } from "rbx";

import { Mutation } from "react-apollo";
import Section from "../Section";
import {
  BooleanInput,
  CurrencySelect,
  ImageUploader,
  EditFormButtonGroup,
  PhoneNumberInput,
  StateSelect,
  SystemCodeSelect,
  ZipCodeInput
} from "../inputs";
import {
  UPDATE_COMPANY_INFO_MUTATION,
  DELETE_COMPANY_INFO_MUTATION
} from "../../graphql/Company/CompanyInfos.graphql";
import { ourToast as toast } from "../../utils";

class EditCompanyInfoForm extends Component {
  state = {
    CompanyId: "",
    ImageUrl: "",
    Name: "",
    Currency: "",
    Address1: "",
    Address2: "",
    City: "",
    State: "",
    ZipCode: "",
    Country: "",
    PhoneNo: "",
    FaxNo: "",
    Active: "",
    RecId: "",
    Website: undefined,
    TimeZoneRecIdRef: "",
    ...this.props.companyInfo
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const {
      CompanyId,
      ImageUrl,
      Name,
      Currency,
      Address1,
      Address2,
      City,
      State,
      ZipCode,
      Country,
      PhoneNo,
      FaxNo,
      Active,
      RecId,
      Website,
      TimeZoneRecIdRef
    } = this.state;
    const { setModalOpen } = this.props;

    return (
      <Mutation
        mutation={UPDATE_COMPANY_INFO_MUTATION}
        refetchQueries={["ALL_COMPANY_INFOS_QUERY"]}
        variables={{
          data: {
            RecId,
            CompanyId,
            ImageUrl,
            Name,
            Currency,
            Address1,
            Address2,
            City,
            State,
            ZipCode,
            Country,
            PhoneNo,
            FaxNo,
            Active,
            Website,
            TimeZoneRecIdRef: parseInt(TimeZoneRecIdRef)
          },
          where: {
            RecId: this.props.companyInfo.RecId
          }
        }}
      >
        {(updateCompanyInfo, { loading }) => (
          <form
            id="edit-company-info"
            onSubmit={async e => {
              e.preventDefault();
              try {
                await updateCompanyInfo();
                setModalOpen(false);
                toast.success("Company updated successfully.");
              } catch (err) {
                toast.error("Error updating Company.");
              }
            }}
          >
            <Fieldset disabled={loading}>
              <Section title="Edit Company">
                <Field kind="group">
                  <Field>
                    <Control>
                      <Label>Image</Label>
                      <ImageUploader
                        name="ImageUrl"
                        value={ImageUrl}
                        onChange={data => this.setState({ ...data })}
                      />
                    </Control>
                  </Field>
                  <Field>
                    <Field>
                      <Control expanded>
                        <Label>Name</Label>
                        <Input
                          autocomplete="new"
                          name="Name"
                          type="text"
                          value={Name}
                          onChange={this.onChange}
                        />
                      </Control>
                    </Field>
                    <Field multiline kind="group">
                      <Control expanded>
                        <Label>Address 1</Label>
                        <Input
                          autocomplete="new"
                          name="Address1"
                          type="text"
                          value={Address1}
                          onChange={this.onChange}
                        />
                      </Control>
                      <Control expanded>
                        <Label>Address 2</Label>
                        <Input
                          autocomplete="new"
                          name="Address2"
                          type="text"
                          value={Address2}
                          onChange={this.onChange}
                        />
                      </Control>
                      <Control>
                        <Label>City</Label>
                        <Input
                          autocomplete="new"
                          name="City"
                          type="text"
                          value={City}
                          onChange={this.onChange}
                        />
                      </Control>
                      <Control expanded>
                        <Label>State</Label>
                        <StateSelect
                          name="State"
                          size=""
                          value={State}
                          onChange={this.onChange}
                        />
                      </Control>
                      <Control>
                        <Label>Zip Code</Label>
                        <ZipCodeInput
                          name="ZipCode"
                          value={ZipCode}
                          onChange={this.onChange}
                        />
                      </Control>
                      <Control expanded>
                        <Label>Country</Label>
                        <Input
                          autocomplete="new"
                          name="Country"
                          type="text"
                          value={Country}
                          onChange={this.onChange}
                        />
                      </Control>
                    </Field>
                  </Field>
                </Field>
                <Field kind="group">
                  <Control expanded>
                    <Label>Phone No</Label>
                    <PhoneNumberInput
                      name="PhoneNo"
                      value={PhoneNo}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Fax No</Label>
                    <PhoneNumberInput
                      name="FaxNo"
                      value={FaxNo}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field kind="group">
                  <Control expanded>
                    <SystemCodeSelect
                      icon="globe"
                      label="Time Zone"
                      lookup={{ Category: "Company", Code: "Time Zone" }}
                      name="TimeZoneRecIdRef"
                      size=""
                      value={TimeZoneRecIdRef}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Website</Label>
                    <Input
                      autocomplete="new"
                      name="Website"
                      pattern="https://.*"
                      size="30"
                      type="url"
                      value={Website}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <CurrencySelect
                      label="Currency"
                      name="Currency"
                      value={Currency}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control>
                    <Label>Active</Label>
                    <BooleanInput
                      name="Active"
                      value={Active}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>

                <EditFormButtonGroup
                  deleteMutation={DELETE_COMPANY_INFO_MUTATION}
                  form="edit-company-info"
                  refetchQueries={["ALL_COMPANY_INFOS_QUERY"]}
                  variables={{
                    where: { RecId: this.props.companyInfo.RecId }
                  }}
                  onComplete={setModalOpen}
                />
              </Section>
            </Fieldset>
          </form>
        )}
      </Mutation>
    );
  }
}

EditCompanyInfoForm.propTypes = {
  setModalOpen: PropTypes.func,
  companyInfo: PropTypes.object
};
export default EditCompanyInfoForm;
